import { get } from "./http";
import { errorHandling } from "./error";

const getUserStatusDetails = async (data) => {
  try {
    return await get(`order-portal/site-selection`,);
  } catch (err) {
   // errorHandling(err?.response?.data);
   return err
  }
};

export { getUserStatusDetails };
